import { jsxs, jsx } from "react/jsx-runtime";
import { Stack, FieldLabel, Inline, Box, Text, FieldMessage } from "braid-design-system";
import { useState } from "react";
import { button, buttonHeight, firstButton, lastButton, selected, error, focusRing } from "./SegmentedButtonSelector.css.mjs";
const SegmentedButtonSelector = ({
  label,
  options,
  value,
  message,
  reserveMessageSpace,
  onChange
}) => {
  const [isFocusedIndex, setIsFocusedIndex] = useState(
    void 0
  );
  const handleOnClick = (event) => {
    const clickedValue = event.currentTarget.getAttribute(
      "value"
    );
    if (clickedValue && options[clickedValue].value !== value) {
      onChange(options[clickedValue].value);
    }
  };
  return /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
    /* @__PURE__ */ jsx(FieldLabel, { htmlFor: "segmented", label }),
    /* @__PURE__ */ jsx(Inline, { space: "none", children: options.map((option, index) => {
      const selected$1 = options[index].value === value;
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: [
            button,
            buttonHeight[options.length],
            ...index === 0 ? [firstButton] : [],
            ...index === options.length - 1 ? [lastButton] : [],
            ...selected$1 ? [selected] : [],
            ...message ? [error] : [],
            ...isFocusedIndex === index ? [focusRing] : []
          ],
          component: "button",
          value: index,
          onClick: handleOnClick,
          onFocus: () => setIsFocusedIndex(index),
          onBlur: () => setIsFocusedIndex(void 0),
          children: /* @__PURE__ */ jsx(Text, { weight: "medium", children: option.text })
        },
        index
      );
    }) }),
    /* @__PURE__ */ jsx(
      FieldMessage,
      {
        id: `${label} message`,
        tone: "critical",
        message,
        reserveMessageSpace
      }
    )
  ] });
};
export {
  SegmentedButtonSelector
};
